import styled from "@emotion/styled";

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.primary100};
`;
export default Divider;
